import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import bbox from "@turf/bbox";

const LAYER_FEATURE_SELECTED = ({ layer, properties }) => {
  const prevPropsRef = useRef();

  const on_render = () => {
    const layer_id_const = "feature_object_selected";
    const { feature_object_selected, map_object } = layer;
    const visibility = "visible";
    if (feature_object_selected === null) {
      if (map_object.getLayer(layer_id_const)) {
        map_object.removeLayer(layer_id_const);
      }
      if (map_object.getSource(layer_id_const)) {
        map_object.removeSource(layer_id_const);
      }
    } else {
      const type = feature_object_selected?.geometry?.type;
      const geojson = {
        type: "FeatureCollection",
        features: [feature_object_selected],
      };
      let type_shape, paint_object, layout_object;
      switch (type) {
        case "Point":
        case "MultiPoint":
          type_shape = "circle";
          paint_object = {
            "circle-radius": 6,
            "circle-color": "transparent",
            "circle-stroke-width": 3,
            "circle-stroke-color": "#000000",
          };
          layout_object = {
            visibility: visibility,
          };
          break;
        case "LineString":
        case "MultiLineString":
        case "Polygon":
        case "MultiPolygon":
          type_shape = "line";
          paint_object = {
            "line-color": "#000000",
            "line-width": 5,
          };
          layout_object = {
            visibility: visibility,
            "line-cap": "round",
            "line-join": "round",
          };
          break;
        default:
          break;
      }
      if (!map_object.getSource(layer_id_const)) {
        map_object.addSource(layer_id_const, {
          type: "geojson",
          data: geojson,
        });
      } else {
        map_object.getSource(layer_id_const).setData(geojson);
      }
      if (!map_object.getLayer(layer_id_const)) {
        map_object.addLayer({
          id: layer_id_const,
          source: layer_id_const,
          type: type_shape,
          paint: paint_object,
          layout: layout_object,
        });
      } else {
        map_object.removeLayer(layer_id_const);
        map_object.addLayer({
          id: layer_id_const,
          source: layer_id_const,
          type: type_shape,
          paint: paint_object,
          layout: layout_object,
        });
      }
    }
  };

  const on_fly = () => {
    const { feature_object_selected, map_object, is_pause_zoom_map } = layer;
    if (map_object && feature_object_selected && !is_pause_zoom_map) {
      const geojson = {
        type: "FeatureCollection",
        features: [feature_object_selected],
      };
      const { is_mobile } = properties;
      const [min_longitude, min_latitude, max_longitude, max_latitude] =
        bbox(geojson);
      setTimeout(
        () => {
          map_object.fitBounds(
            [
              [min_longitude, min_latitude],
              [max_longitude, max_latitude],
            ],
            {
              padding: layer.padding_fly,
              maxZoom: layer.max_zoom,
              duration: 750,
            }
          );
          map_object.resize();
        },
        is_mobile ? 300 : 0
      );
    }
  };

  useEffect(() => {
    const prevProps = prevPropsRef.current;

    if (prevProps) {
      const key_after = layer.feature_object_selected?.properties?.key;
      const key_before =
        prevProps.layer.feature_object_selected?.properties?.key;
      const id_after = layer.feature_object_selected?.id;
      const id_before = prevProps.layer.feature_object_selected?.id;
      const key_original_after = layer.feature_object_selected?.key;
      const key_original_before = prevProps.layer.feature_object_selected?.key;

      const geometryStatus_after = layer.geometryStatus;
      const geometryStatus_before = prevProps.layer.geometryStatus;

      if (
        key_after !== key_before ||
        id_after !== id_before ||
        key_original_after !== key_original_before ||
        geometryStatus_after !== geometryStatus_before
      ) {
        const { map_object } = layer;
        if (map_object !== null) {
          on_fly();
          on_render();
        }
      }
    }

    // Store current props for next comparison
    prevPropsRef.current = { layer, properties };
  });

  return <main />;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {})(LAYER_FEATURE_SELECTED);
